import styled, { css } from 'styled-components'

import { Chip } from '@/components/business/market-shop/chip'
import { Icon } from '@/components/ui/icon'
import { Typography } from '@/components/ui/typography'

import {
  DESCRIPTION_COLLAPSED_HEIGHT_REM,
  DESCRIPTION_LINE_HEIGHT_REM,
} from './product-details.constants'

export const Content = styled.div(
  ({ theme }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: ${theme.space['16']};
  `,
)

export const ImageContainer = styled.div(
  ({ theme }) => css`
    position: relative;
    display: grid;
    place-content: center;
    width: 100%;
    height: 100%;
    max-height: 30rem;
    background-color: ${theme.colors.gray300};
    border-radius: ${theme.border.radius['12']};
    overflow: hidden;
  `,
)

export const TagsColumn = styled.div(
  ({ theme }) => css`
    position: absolute;
    top: ${theme.space['8']};
    left: ${theme.space['12']};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.space['4']};
  `,
)

export const DiscountChip = styled(Chip)``

export const NewChip = styled(Chip)``

export const Image = styled.img(
  () => css`
    width: 100%;
    max-height: 30rem;
    object-fit: scale-down;
  `,
)

export const PlaceholderIcon = styled(Icon)(
  ({ theme }) => css`
    color: ${theme.colors.gray600};
  `,
)

export const Title = styled(Typography)(
  ({ theme }) => css`
    padding: ${theme.space['12']} ${theme.space['0']} ${theme.space['4']};
  `,
)

export const PriceGroup = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.space['4']};
  `,
)

export const OriginalPrice = styled(Typography)(
  () => css`
    text-decoration: line-through;
  `,
)

export const DescriptionText = styled(Typography)<{ $isExpanded: boolean }>(
  ({ $isExpanded }) => css`
    line-height: ${DESCRIPTION_LINE_HEIGHT_REM};
    position: relative;
    flex-shrink: 0;

    ${
      !$isExpanded &&
      css`
      max-height: ${DESCRIPTION_COLLAPSED_HEIGHT_REM};
      overflow: hidden;
    `
    }
  `,
)

export const ShowMoreButton = styled.button<{ $isInline?: boolean }>(
  ({ theme, $isInline }) => css`
    background-color: ${theme.colors.white};
    border: none;
    padding: 0 0 0 ${theme.space['4']};
    cursor: pointer;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;

    ${
      $isInline
        ? css`
          display: inline;
        `
        : css`
          position: absolute;
          bottom: 0;
          right: 0;
        `
    }
  `,
)

export const Ellipsis = styled.span(
  ({ theme }) => css`
    padding-right: ${theme.space['4']};
  `,
)

export const ButtonText = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.black800};
    font-weight: 700;
    text-decoration: underline;
  `,
)

export const HowManyContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['8']};
  `,
)

export const HowManyControls = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['8']};
  `,
)

export const Count = styled(Typography)(
  ({ theme }) => css`
    min-width: 1.6rem;
    margin: ${theme.space['0']} auto;
  `,
)

export const Controls = styled.div<{ $grid?: boolean }>(
  ({ theme, $grid }) => css`
    position: sticky;
    bottom: 0;
    display: ${$grid ? 'grid' : 'flex'};
    ${$grid && `grid-template-columns: auto 1fr;`}
    flex-direction: column;
    gap: ${theme.space['8']};
    margin-top: auto;
    padding: ${theme.space['16']};
    background-color: ${theme.colors.white};
    box-shadow: ${theme.shadow.marketShopShadow};
  `,
)
